module.exports = __webpack_public_path__ + "static/media/background-light.262b7469.png";